/** блок адаптации **/
import './common/adapterFromOldStyle'
/** блок адаптации **/

import { eventEmitter, isAuth, lang, sessid } from './common/baseData'
import {BlogList} from './blog/blog-list';
import './blog/style.css';
import './pagenavigation/style.css';
import './blog/share-socials';
import './blog/catalog-list';
import 'goodshare.js';
import Sorting from './components/categoryPage/sorting/Sorting';
import {RatingVoteItem} from './ratingVoteItem';
import React, { lazy, Suspense } from 'react'
import ReactDOM from 'react-dom'
import {createRoot} from 'react-dom/client'
import ViewedProductsSlider from './components/viewedProductsSlider/ViewedProductsSlider'
import TextElementProductsSlider from './components/textElementProductsSlider/TextElementProductsSlider'
var Inputmask = require('inputmask');


BlogList.init();

//Product list
const productReview = document.querySelector('[data-id=site-news-catalog-list]');
if (productReview instanceof HTMLElement) {
    // Wish list on blog page
    eventEmitter.emit('handleWishlistItems', {
        node: productReview.querySelectorAll('[data-container="favorite"]'),
        range: 'productReview'
    });

    eventEmitter.emit('handleCompareItems', {
        node: productReview.querySelectorAll('[data-container="compare"]'),
        range: 'productReview'
    });
}

let shareLinkNode = document.querySelector('.js-share');
if (shareLinkNode instanceof HTMLElement) {
    import(/* webpackChunkName: 'sharelink' */ 'clipboard-copy').then(module => {
        let clipboardCopy = module.default;
        let shareBlock = shareLinkNode.querySelector('.article-share');
        let shareLink = shareLinkNode.querySelector('.article-link');
        let shareLinkSaved = shareLinkNode.querySelector('.article-saved');
        let linkNode = shareLink.querySelector('span');
        shareBlock.addEventListener('click', e => {
            console.log(linkNode.textContent);
            clipboardCopy(linkNode.textContent);
            shareBlock.classList.remove('active');
            shareLinkSaved.classList.add('active');
            setTimeout(() => {
                shareBlock.classList.add("active");
                shareLinkSaved.classList.remove('active');
            }, 3000);
        });
    });
}

let paginationBlock = document.querySelector('[data-container="page-paging"]');
if (paginationBlock instanceof HTMLElement) {
    try {
        import(/* webpackPreload: true */ './pagenavigation')
          .then(({default: CatalogPagenation}) => {
            let params = JSON.parse(atob(paginationBlock.dataset['params']));
            params.node = paginationBlock;
            let pagen = new CatalogPagenation(params);
            pagen.init();
        });
    } catch (e) {
        console.error(e);
    }
}

// Sort
let catalogSortBlock = document.querySelector('[data-container="page-sort"]');
if (catalogSortBlock instanceof HTMLElement) {
  try {
    let params = JSON.parse(atob(catalogSortBlock.dataset['params']));
    createRoot(catalogSortBlock).render(
      <Sorting options={params.sortValues}
               messages={params.messages}
               onChange={option => {
                 if (option.queryString) location.href = option.queryString;
               }}/>
    );
  } catch (e) {
    console.error(e);
  }
}

// Comments create logic
[].slice.apply(document.body.querySelectorAll('[data-container="comment"][data-use="create-comment"]'))
    .forEach(button => {
        button.addEventListener('click', event => {
            event.preventDefault();
            let el = event.target, holder = el.closest('.dropdown-main-container');
            let data = {
                component: {
                    params: el.dataset.params,
                    component: el.dataset.component,
                    commentCreateTemplate: el.dataset.commentCreateTemplate,
                    commentSuccessTemplate: el.dataset.commentSuccessTemplate
                },
                postId: el.dataset.postId,
                blogId: el.dataset.blogId,
                productId: el.dataset.productId,
                loadUrl: atob(el.dataset.loadUrl),
                editUrl: atob(el.dataset.editUrl)
            };

            import(/* webpackChunkName: 'productreview' */ './productReview').then(module => {
                let productReview = new module.ProductReview(data);
                productReview.loadCommentTemplate()
                    .then(response => {
                        return response.json();
                    })
                    .then(data => {
                        if (data.hasOwnProperty('html') && data.html.length) {
                            holder.insertAdjacentHTML('beforeEnd', data.html);
                            // Show comment block
                            holder.querySelector('.dropdown-holder').setAttribute('style', 'visibility: visible; opacity: 1; z-index: 1;');
                            // Form submit event, check fields and send form data
                            holder.querySelector('form[name="comment"]')
                                .addEventListener('submit', event => {
                                    event.preventDefault();
                                    // Validate data
                                    if (productReview.validate(event.target)) {
                                        // Prepare comment data
                                        let requestData = productReview.fieldsData(event.target);
                                        requestData.append('action', 'createReview');
                                        requestData.append('parentId', el.dataset.reviewId);
                                        requestData.append('postId', productReview.postId);
                                        requestData.append('blogId', productReview.blogId);
                                        requestData.append('productId', productReview.productId);
                                        productReview.sendCommentData(requestData) // Send review data
                                            .then(response => {
                                                return response.json(); // Parse json response
                                            })
                                            .then(response => { // Processing response
                                                if (response.success && parseInt(response.reviewId, 10) > 0) { // Review success created
                                                    return productReview.loadCommentSuccessTemplate(); // Load success template
                                                } else if (response.errors.length > 0) {
                                                    let text = response.errors.join(", ");
                                                    throw text;
                                                }
                                            })
                                            .then(response => {
                                                return response.json();
                                            })
                                            .then(response => { // Processing success template
                                                if (response.hasOwnProperty('html') && response.html.length) {
                                                    holder.querySelector('.dropdown-content-te').innerHTML = response.html;
                                                }
                                            }).catch(e => {
                                            console.dir(e);
                                            holder.querySelector('.dropdown-content-te').innerHTML = e;
                                        });
                                    }
                                });
                            // Change fields values
                            holder.querySelector('form[name="comment"]')
                                .addEventListener('change', event => {
                                    event.preventDefault();
                                    // Validate data
                                    productReview.validateField(event.target);
                                    // Toggle has value
                                    productReview.toggleInputHasValue(event.target);
                                });
                            // Close comment block
                            holder.querySelector('.close')
                                .addEventListener('click', event => {
                                    let dropHolder = holder.querySelector('.dropdown-holder');
                                    if (dropHolder instanceof HTMLElement) {
                                        holder.removeChild(dropHolder);
                                    }
                                });
                        }
                    });
            });
        });
    });

// Review show comments logic
[].slice.apply(document.body.querySelectorAll('[data-container="review"][data-use="show-comments"]'))
    .forEach(button => {
        button.addEventListener('click', event => {
            event.preventDefault();
            let el = event.target;
            // Find all comments
            let commentsHolder = el.closest('.testimonial-block')
                .querySelector('[data-container="review"][data-use="comments-holder"]');
            if (commentsHolder instanceof HTMLElement) {
                commentsHolder.style.display = 'block';
            }
        });
    });

// Reviews work logic
[].slice.apply(document.body.querySelectorAll('[data-container="review"][data-use="add"]'))
    .forEach(button => {
        button.addEventListener('click', event => {
            let el = event.target;
            let data = {
                component: {
                    params: el.dataset.params,
                    component: el.dataset.component,
                    reviewCreateTemplate: el.dataset.reviewCreateTemplate,
                    reviewSuccessTemplate: el.dataset.reviewSuccessTemplate
                },
                postId: el.dataset.postId,
                blogId: el.dataset.blogId,
                productId: el.dataset.productId,
                loadUrl: atob(el.dataset.loadUrl),
                editUrl: atob(el.dataset.editUrl),
                messages: JSON.parse(atob(el.dataset.messages))
            };
    
            import(/* webpackPreload: true */ './blogReview')
              .then(module => {
                let blogReview = new module.BlogReview(data);
                blogReview.loadTemplateData()
                    .then(response => {
                        return response.json();
                    })
                    .then(data => {
                        if (data.hasOwnProperty('html') && data.html.length) {
                            button.remove();
                            const reviewSectionNode = document.querySelector('#section-testimonials');
                            if (reviewSectionNode instanceof HTMLElement) {
                                reviewSectionNode.insertAdjacentHTML('beforeend', data.html);
                                // email input mask
                                let emailInputMask = document.getElementById("email-input-mask");
                                if(emailInputMask) {
                                    var emailMask = new Inputmask("*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@*{1,20}.*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]");
                                    emailMask.mask(emailInputMask);
                                }

                                let form = reviewSectionNode.querySelector('form');
                                form.addEventListener('submit', event => {
                                    event.preventDefault();
                                    // Validate data
                                    if (blogReview.validate(form)) {
                                        blogReview.sendReviewData(form) // Send review data
                                            .then(response => {
                                                return response.json(); // Parse json response
                                            })
                                            .then(response => { // Processing response
                                                if (response.success && parseInt(response.reviewId, 10) > 0) { // Review success created
                                                    return blogReview.loadSuccessTemplate(); // Load success template
                                                } else console.log('Some error');
                                            })
                                            .then(response => {
                                                return response.json();
                                            })
                                            .then(response => { // Processing success template
                                                if (response.hasOwnProperty('html') && response.html.length) {
                                                    let formParentNode = form.parentElement;
                                                    formParentNode.innerHTML = response.html;
                                                }
                                            });
                                    }
                                });

                                // Change fields values
                                form.addEventListener('change', event => {
                                    event.preventDefault();
                                    // Validate data
                                    blogReview.validateField(event.target);
                                    // Toggle has value
                                    blogReview.toggleInputHasValue(event.target);
                                });

                            }
                        }
                    });
            });
        });
    });


//News vote handling
let voteNewsItem = document.querySelector('[data-container="vote-news"]');
if((voteNewsItem instanceof HTMLElement)
    && voteNewsItem.dataset.hasOwnProperty('params')) {
    let voteParams = JSON.parse(atob(voteNewsItem.dataset.params));
    let voteNewsItemHandler = new RatingVoteItem(voteParams);

    let newsLikeList = [].slice.apply(document.querySelectorAll('[data-container="vote-news"] > [data-type="like"]'));
    let newsDislikeList = [].slice.apply(document.querySelectorAll('[data-container="vote-news"] > [data-type="dislike"]'));

    let newsUserVote = voteNewsItemHandler.getUserVote();

    if(newsLikeList.length > 0) {
        newsLikeList.forEach(item => {
            if(newsUserVote > 0)
                item.classList.add('active');

            item.addEventListener('click', e => {
                e.preventDefault();

                voteNewsItemHandler.sendVote('like').then(result => {
                    if(!result.status) return;

                    if(result.action === 'cancel') {
                        newsLikeList.map(item => {
                            item.classList.remove('active');
                            let counterNode = item.querySelector('[data-container="counter"]')
                            if(counterNode instanceof HTMLElement)
                                counterNode.innerHTML = result.like;
                        });
                    } else {
                        newsLikeList.map(item => {
                            item.classList.add('active');
                            let counterNode = item.querySelector('[data-container="counter"]')
                            if(counterNode instanceof HTMLElement)
                                counterNode.innerHTML = result.like;
                        });
                    }
                    newsDislikeList.map(item => {
                        item.classList.remove('active');
                        let counterNode = item.querySelector('[data-container="counter"]')
                        if(counterNode instanceof HTMLElement)
                            counterNode.innerHTML = result.dislike;
                    });
                });
            });
        });
    }

    if(newsDislikeList.length > 0) {
        newsDislikeList.forEach(item => {
            if(newsUserVote < 0)
                item.classList.add('active');


            item.addEventListener('click', e => {
                e.preventDefault();

                voteNewsItemHandler.sendVote('dislike').then(result => {
                    if(!result.status) return;

                    if(result.action === 'cancel') {
                        newsDislikeList.map(item => {
                            item.classList.remove('active');
                            let counterNode = item.querySelector('[data-container="counter"]')
                            if(counterNode instanceof HTMLElement)
                                counterNode.innerHTML = result.dislike;
                        });
                    } else {
                        newsDislikeList.map(item => {
                            item.classList.add('active');
                            let counterNode = item.querySelector('[data-container="counter"]')
                            if(counterNode instanceof HTMLElement)
                                counterNode.innerHTML = result.dislike;
                        });
                    }
                    newsLikeList.map(item => {
                        item.classList.remove('active');
                        let counterNode = item.querySelector('[data-container="counter"]')
                        if(counterNode instanceof HTMLElement)
                            counterNode.innerHTML = result.like;
                    });
                });
            });
        });
    }
}


//Comment vote handling
let voteItems = document.querySelectorAll('[data-container="vote"]');
if(voteItems.length > 0) {
    voteItems.forEach(item => {
        if(!item.dataset.hasOwnProperty('params')) return;
        let params = JSON.parse(atob(item.dataset.params));
        let voteItemHandler = new RatingVoteItem(params);
        let userVote = voteItemHandler.getUserVote();

        let like = item.querySelector('[data-type="like"]');
        let disLike = item.querySelector('[data-type="dislike"]');

        if(userVote > 0)
            like.classList.add('active');
        else if(userVote < 0)
            disLike.classList.add('active');

        if(like instanceof HTMLElement) {
            like.addEventListener('click', e => {
                e.preventDefault();

                voteItemHandler.sendVote('like').then(result => {
                    if(!result.status) return;

                    if(result.action === 'cancel') {
                        like.classList.remove('active');
                    } else {
                        like.classList.add('active');
                        if(disLike instanceof HTMLElement)
                            disLike.classList.remove('active');
                    }

                    let likeCounterNode = like.querySelector('[data-container="counter"]')
                    if(likeCounterNode instanceof HTMLElement)
                        likeCounterNode.innerHTML = result.like;

                    let disLikeCounterNode = disLike.querySelector('[data-container="counter"]')
                    if(disLikeCounterNode instanceof HTMLElement)
                        disLikeCounterNode.innerHTML = result.dislike;
                });
            });
        }

        if(disLike instanceof HTMLElement) {
            disLike.addEventListener('click', e => {
                e.preventDefault();

                voteItemHandler.sendVote('dislike').then(result => {
                    if(!result.status) return;

                    if(result.action === 'cancel') {
                        like.classList.remove('active');
                    } else {
                        disLike.classList.add('active');
                        if(like instanceof HTMLElement)
                            like.classList.remove('active');
                    }

                    let likeCounterNode = like.querySelector('[data-container="counter"]')
                    if(likeCounterNode instanceof HTMLElement)
                        likeCounterNode.innerHTML = result.like;

                    let disLikeCounterNode = disLike.querySelector('[data-container="counter"]')
                    if(disLikeCounterNode instanceof HTMLElement)
                        disLikeCounterNode.innerHTML = result.dislike;
                });
            });
        }

    });
}


// Товары в описании новости
new TextElementProductsSlider().init();
// Просмотренные твоары
new ViewedProductsSlider().init()